import * as React from 'react';

import KeyInformationCourseDurationAndSchedule from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationCourseDurationAndSchedule';
import { KeyInformationItemNames } from 'bundles/unified-description-page-common/types/moduleConfig';

const combineCourseDurationAndSchecule = ({
  items,
  totalDuration,
}: {
  items: (JSX.Element | null)[];
  totalDuration?: string | null;
}) => {
  if (
    items.find((item) => item?.key === KeyInformationItemNames.Schedule) &&
    items.find((item) => item?.key === KeyInformationItemNames.Duration)
  ) {
    const newItems = items.filter((item) => item?.key !== KeyInformationItemNames.Schedule);
    const durationIndex = newItems.findIndex((item) => item?.key === KeyInformationItemNames.Duration);

    newItems.splice(
      durationIndex,
      1,
      <KeyInformationCourseDurationAndSchedule
        key={KeyInformationItemNames.Duration}
        totalDuration={totalDuration ?? ''}
      />
    );
    return newItems;
  }

  return items;
};

export default combineCourseDurationAndSchecule;
